import { render, staticRenderFns } from "./Curator.vue?vue&type=template&id=550fd58b&scoped=true&"
import script from "./Curator.vue?vue&type=script&lang=js&"
export * from "./Curator.vue?vue&type=script&lang=js&"
import style0 from "./Curator.vue?vue&type=style&index=0&id=550fd58b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550fd58b",
  null
  
)

export default component.exports